import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'removeNull'
})
export class RemoveNullPipe implements PipeTransform {

  transform(value: string): unknown {
    if (!value) {
      return;
    }
    return value.replace(/null /g, '');
  }

}
